import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import S3Upload from 'react-s3-uploader/s3upload';

import Api from 'entities/api';
import './cke.css';

const getSignedUrl = (file, callback) => {
  Api.post('api/files/credentials', {
    // eslint-disable-next-line camelcase
    file_name: S3Upload.prototype.scrubFilename(file.name),
    // eslint-disable-next-line camelcase
    file_type: file.type,
  }).subscribe(
    (response) =>
      // eslint-disable-next-line n/no-callback-literal
      callback({
        signedUrl: response.signedRequest,
        publicUrl: response.url,
      }),
    (e) => console.error(e) // eslint-disable-line no-console
  );
};

class S3UploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  upload() {
    return new Promise((resolve, reject) => {
      const { file } = this.loader;
      this.loader.uploadTotal = file.size;
      const options = {
        files: [file],
        getSignedUrl,
        contentDisposition: 'auto',
        uploadRequestHeaders: { 'x-amz-acl': 'public-read' },
        onFinishS3Put: (info) => {
          resolve({ default: info.publicUrl });
        },
        onProgress: (progress) => {
          this.loader.uploaded = (this.loader.uploadTotal * progress) / 100;
        },
        onError: (error) => {
          console.error(error); // eslint-disable-line no-console
          reject(error);
        },
      };
      new S3Upload(options); // eslint-disable-line no-new
    });
  }

  abort() {
    console.log('Aborting file upload not implemented, sorry!'); // eslint-disable-line no-console
  }
}

function S3UploadAdapterPlugin(editor) {
  // eslint-disable-next-line no-param-reassign
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) =>
    new S3UploadAdapter(loader);
}

const Wrapper = styled.div`
  .ck-editor__editable {
    min-height: ${(props) => props.height}px !important;
  }
`;

const RteField = ({ input, placeholder, height = 300 }) => (
  <Wrapper height={height}>
    <CKEditor
      editor={ClassicEditor}
      config={{
        // Note that content from CKE5 is also sanitized server-side based on a white-list
        // so it would need to be adjusted if new plugins are added
        removePlugins: ['BlockQuote', 'MediaEmbed', 'CKFinder', 'Table', 'TableToolbar'],
        extraPlugins: [S3UploadAdapterPlugin],
        image: { styles: ['full'] },
        placeholder,
      }}
      data={input.value}
      onChange={(e, editor) => {
        const data = editor.getData();
        if (typeof input.onChange === 'function') {
          input.onChange(data);
        }
      }}
    />
  </Wrapper>
);

RteField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  placeholder: PropTypes.string,
  height: PropTypes.number,
};

export default RteField;
